export default "__VITE_ASSET__CVOlQQQg__"